module.exports = __webpack_public_path__ + "static/media/unionpay.f8c7f2cc.jpg";